<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@vueuse/core';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import FACEBOOKCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/FACEBOOKCampaign/FACEBOOKCampaignDialog.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import FACEBOOKCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/FACEBOOKCampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const selectedCampaign = ref(null);
const [showFACEBOOKCampaignDialog, toggleFACEBOOKCampaignDialog] = useToggle();

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const confirmDeleteCampaignDialogRef = ref(null);

const FACEBOOKCampaigns = computed(() =>
  getters['campaigns/getCampaignsByChannelTypes'].value([
    'Channel::FacebookPage',
  ])
);

const hasNoFACEBOOKCampaigns = computed(
  () => FACEBOOKCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :button-label="t('CAMPAIGN.FACEBOOK.NEW_CAMPAIGN')"
    :header-title="t('CAMPAIGN.FACEBOOK.HEADER_TITLE')"
    @click="toggleFACEBOOKCampaignDialog()"
    @close="toggleFACEBOOKCampaignDialog(false)"
  >
    <template #action>
      <FACEBOOKCampaignDialog
        v-if="showFACEBOOKCampaignDialog"
        @close="toggleFACEBOOKCampaignDialog(false)"
      />
    </template>
    <div
      v-if="isFetchingCampaigns"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <CampaignList
      v-else-if="!hasNoFACEBOOKCampaigns"
      :campaigns="FACEBOOKCampaigns"
      @delete="handleDelete"
    />
    <FACEBOOKCampaignEmptyState
      v-else
      :subtitle="t('CAMPAIGN.FACEBOOK.EMPTY_STATE.SUBTITLE')"
      :title="t('CAMPAIGN.FACEBOOK.EMPTY_STATE.TITLE')"
      class="pt-14"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template>
